import api from '../../../api/client';
import React, { useState, useEffect } from "react";
import {
  Layout,
  Card,
  Row,
  Col,
  Statistic,
  Alert,
  Typography,
  Spin,
  Tag,
  Progress,
} from "antd";
import {
  EnvironmentOutlined,
  DropboxOutlined,
  CloudOutlined,
  AlertOutlined,
  ToolOutlined,
  HeartFilled,
} from "@ant-design/icons";
import WeatherDisplay from "../../../components/WeatherDisplay";
// import FarmInsights from "./components/FarmInsights";
// import AnimalInsights from "./components/AnimalInsights";
// import WeatherCharts from "./components/WeatherCharts";
// import AnimalMetrics from "./components/AnimalMetrics";
// import CropGrowthChart from "./components/CropGrowthChart";
// import FarmManagement from "./components/FarmManagement";
import config from "../../../config";
import WeatherCharts from "../../../components/WeatherCharts";
import AnimalMetrics from "../../../components/AnimalsMetrics";
import CropGrowthChart from "../../../components/CropGrwothChart";
import FarmManagement from "../../../components/FarmManagement";
import FarmInsights from "../../../components/FarmInsights";
import AnimalInsights from "../../../components/AnimalInsights";
import { FaTemperatureHigh } from "react-icons/fa";

const { Header, Content } = Layout;
const { Title, Text } = Typography;

function FarmDashboard() {
  const [weatherData, setWeatherData] = useState(null);
  const [forecastData, setForecastData] = useState(null);
  const [historicalData, setHistoricalData] = useState(null);
  const [farmInsights, setFarmInsights] = useState(null);
  const [farmData, setFarmData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [userLocation, setUserLocation] = useState(null);
  const [error, setError] = useState(null);
  const environment =
    window.location.hostname === "localhost" ? "development" : "production";
  const apiUrl = config[environment].apiUrl;

  useEffect(() => {
    getUserLocation();
  }, []);

  const getUserLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const location = {
            lat: position.coords.latitude,
            lon: position.coords.longitude,
          };
          setUserLocation(location);
          fetchAllData(location);
        },
        (error) => {
          console.error("Geolocation error:", error);
          const defaultLocation = { lat: 39.0997, lon: -94.5786 };
          setUserLocation(defaultLocation);
          fetchAllData(defaultLocation);
          setError(
            "Using default location. Enable location services for accurate data.",
          );
        },
      );
    } else {
      setError("Geolocation is not supported by this browser.");
    }
  };

  const fetchAllData = async (location) => {
    setLoading(true);
    try {
      const [weatherRes, forecastRes, insightsRes, farmRes, historicalRes] =
        await Promise.all([
          fetch(
            `/api/weather?lat=${location.lat}&lon=${location.lon}`,
          ),
          fetch(
            `/api/weather-forecast?lat=${location.lat}&lon=${location.lon}`,
          ),
          fetch(
            `/api/farm-insights?lat=${location.lat}&lon=${location.lon}`,
          ),
          fetch(`/api/farm-data?userId=default`),
          fetch(`/api/historical-data?days=7`),
        ]);

      const weather = await weatherRes.json();
      const forecast = await forecastRes.json();
      const insights = await insightsRes.json();
      const farm = await farmRes.json();
      const historical = await historicalRes.json();
setWeatherData(weather);
      setForecastData(forecast);
      setHistoricalData(historical);
      setFarmInsights(insights);
      setFarmData(farm);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Failed to fetch data from server");
    } finally {
      setLoading(false);
    }
  };

  const refreshData = () => {
    if (userLocation) {
      fetchAllData(userLocation);
    }
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin size="large" tip="Loading Farm Dashboard..." />
      </div>
    );
  }

  return (
    <>
      <div style={{ marginLeft: "auto" }}>
        {userLocation && (
          <Text>
            <EnvironmentOutlined /> Location: {userLocation.lat.toFixed(4)},{" "}
            {userLocation.lon.toFixed(4)}
          </Text>
        )}
      </div>
      {/* </Header> */}

      <Content>
        {error && (
          <Alert
            message={error}
            type="warning"
            showIcon
            closable
            style={{ marginBottom: "24px" }}
          />
        )}

        <Row gutter={[24, 24]}>
          {/* Weather Overview */}

          {/* Farm Insights */}
          <Col xs={24} lg={24}>
            <FarmInsights insights={farmInsights} farmData={farmData} />
          </Col>

          {/* Quick Stats */}
          <Col xs={24}>
            <Card title="Farm Overview" bordered={false}>
              <Row gutter={[16, 16]}>
                <Col xs={12} sm={6}>
                  <Statistic
                    title="Soil Moisture"
                    value={farmInsights?.crops?.soilMoisture || 0}
                    suffix="%"
                    prefix={<CloudOutlined />}
                    valueStyle={{ color: "#1890ff" }}
                  />
                  <Progress
                    percent={farmInsights?.crops?.soilMoisture || 0}
                    size="small"
                    status={
                      farmInsights?.crops?.soilMoisture > 80
                        ? "exception"
                        : farmInsights?.crops?.soilMoisture < 30
                        ? "active"
                        : "normal"
                    }
                  />
                </Col>
                <Col xs={12} sm={6}>
                  <Statistic
                    title="Pest Risk"
                    value={
                      farmInsights?.crops?.pestRisk?.risk.toUpperCase() || "LOW"
                    }
                    prefix={<AlertOutlined />}
                    valueStyle={{
                      color:
                        farmInsights?.crops?.pestRisk?.risk === "high"
                          ? "#cf1322"
                          : farmInsights?.crops?.pestRisk?.risk === "medium"
                          ? "#faad14"
                          : "#52c41a",
                    }}
                  />
                </Col>
                <Col xs={12} sm={6}>
                  <Statistic
                    title="Animal Health Risk"
                    value={
                      farmInsights?.animals?.healthRisk?.risk.toUpperCase() ||
                      "LOW"
                    }
                    prefix={<HeartFilled />}
                    valueStyle={{
                      color:
                        farmInsights?.animals?.healthRisk?.risk === "high"
                          ? "#cf1322"
                          : farmInsights?.animals?.healthRisk?.risk === "medium"
                          ? "#faad14"
                          : "#52c41a",
                    }}
                  />
                </Col>
                <Col xs={12} sm={6}>
                  <Statistic
                    title="Current Temp"
                    value={weatherData?.temperature || 0}
                    suffix="°C"
                    prefix={<FaTemperatureHigh />}
                    valueStyle={{ color: "#fa541c" }}
                  />
                </Col>
              </Row>
            </Card>
          </Col>

          {/* Weather Charts */}
          <Col xs={24}>
            <WeatherCharts
              forecastData={forecastData}
              historicalData={historicalData}
            />
          </Col>

          {/* Animal Insights */}
          {/* {farmData?.animalType && farmData.animalType !== "none" && ( */}
          <Col xs={24}>
            <AnimalInsights
              insights={farmInsights?.animals}
              animalType={farmData?.animalType}
              animalCount={farmData?.animalCount}
            />
          </Col>
          {/* )} */}

          {/* Animal Metrics Charts */}
          {/* {farmData?.animalType && farmData.animalType !== "none" && ( */}
          <Col xs={24}>
            <AnimalMetrics
              animalType={farmData?.animalType}
              animalCount={farmData?.animalCount}
            />
          </Col>
          {/* )} */}

          {/* Crop Growth Chart */}
          <Col xs={24}>
            <CropGrowthChart cropType={farmData?.cropType || "wheat"} />
          </Col>

          {/* Farm Management */}
          {/* <Col xs={24}>
            <FarmManagement farmData={farmData} onUpdate={refreshData} />
          </Col> */}
        </Row>
      </Content>
    </>
  );
}

export default FarmDashboard;
